import { WebParameterContext, WebResponesContext } from '../../model/common';
declare var app;
export class ServicesCalendar {
    constructor() { }

    public HandleWebParameterContextBeforeDBRequest(webcontext: WebParameterContext): WebParameterContext {
        const ZhangHu = JSON.parse(localStorage.getItem('account')).LoginName || '';

        webcontext.RequestBody = JSON.stringify({ 'a_ZhangHu': ZhangHu });

        webcontext.ResponseMessage.Success = true;
        webcontext.ResponseMessage.ErrorMessage = "";
        return webcontext;
    }
    public HandleServerContextAfterDBRequest(webParameterContext: WebParameterContext, webContext: WebResponesContext): WebResponesContext {
        return webContext;
    }



}